import { useEffect, useState } from "react";
import * as AD from "@radix-ui/react-alert-dialog";

let push = null;
const ask = (opts) => new Promise((resolve) => (push ? push({ ...opts, resolve }) : resolve(opts.input !== undefined ? null : false)));

export const confirmSheet = (opts) => ask(opts);
export const promptSheet = (opts) => ask({ input: "", ...opts });

export function ActionSheetHost() {
  const [s, setS] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => { push = (o) => { setVal(o.input ?? ""); setS(o); }; return () => { push = null; }; }, []);
  const isPrompt = s?.input !== undefined;
  const blocked = isPrompt && s?.required && !val.trim();
  const done = (ok) => { if (!s) return; s.resolve(isPrompt ? (ok ? val : null) : ok); setS(null); };
  const btn = "block h-[56px] w-full text-[17px] transition-colors active:bg-black/5";
  return (
    <AD.Root open={!!s} onOpenChange={(o) => !o && done(false)}>
      <AD.Portal>
        <AD.Overlay className="fixed inset-0 z-[100] bg-black/30" onClick={() => done(false)} />
        <AD.Content data-testid="action-sheet" onEscapeKeyDown={() => done(false)}
          onOpenAutoFocus={(e) => { if (isPrompt) { e.preventDefault(); document.querySelector('[data-testid="action-sheet-input"]')?.focus(); } }}
          className="action-sheet-in fixed inset-x-0 bottom-0 z-[101] mx-auto w-full max-w-[420px] space-y-2 p-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] outline-none sm:bottom-auto sm:top-1/2 sm:-translate-y-1/2">
          <div className="overflow-hidden rounded-[14px] bg-white/95 text-center backdrop-blur-xl">
            <div className="px-4 py-3.5">
              <AD.Title data-testid="action-sheet-title" className="text-[13px] font-semibold text-[#3C3C43]/70">{s?.title}</AD.Title>
              <AD.Description data-testid="action-sheet-message" className="mt-0.5 text-[13px] text-[#3C3C43]/60">{s?.message || ""}</AD.Description>
              {isPrompt && (
                <input data-testid="action-sheet-input" autoFocus value={val} placeholder={s.placeholder} onChange={(e) => setVal(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && !blocked && done(true)}
                  className="mt-3 h-10 w-full rounded-[10px] border border-black/10 bg-white px-3 text-[15px] outline-none focus:border-[#007AFF]" />
              )}
            </div>
            <button data-testid="action-sheet-confirm" disabled={blocked} onClick={() => done(true)}
              className={`${btn} border-t border-black/10 disabled:opacity-40 ${s?.destructive ? "text-[#FF3B30]" : "text-[#007AFF]"}`}>{s?.confirm || "OK"}</button>
          </div>
          <AD.Cancel data-testid="action-sheet-cancel" onClick={() => done(false)} className={`${btn} rounded-[14px] bg-white font-semibold text-[#007AFF]`}>Cancel</AD.Cancel>
        </AD.Content>
      </AD.Portal>
    </AD.Root>
  );
}
